exports.Feed = [
  {
    title: "Who are you and why you're standing here?",
    post: `It doesn't matter if you're building the next Facebook, or if
    you're the director of marketing for an industrial company. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Vestibulum est libero, porta elementum scelerisque fermentum,
    rhoncus sodales metus Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Vestibulum est libero, porta elementum scelerisque fermentum,
    rhoncus sodales metus `,
    author: `Nicholas O'Brian`,
    posted: "28 July",
    likedcount: 76,
    background: "",
    comments: [
      {
        comment:
          "Pellentesque varius neque in turpis faucibus, eu lobortis ex lacinia. Aenean porta posuere nisi ac fringilla. Sed sapien sapien, tempus quis laoreet nec, tincidunt vel ex. Nam at libero auctor, semper ipsum a, bibendum justo.",
        author: "Jamie",
      },
      {
        comment:
          "Donec varius neque malesuada lobortis tempus. Pellentesque lobortis ac felis id auctor. Sed a enim ligula. Quisque in metus ultrices, pretium orci at, vestibulum massa",
        author: "Heinrich",
      },
    ],
    likedby: [],
  },
  {
    title: `porta elementum scelerisque fermentum`,
    post: ` Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  Vestibulum est libero, porta elementum scelerisque fermentum,
  rhoncus sodales metus Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  Vestibulum est libero, porta elementum scelerisque fermentum,
  rhoncus sodales metus Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  Vestibulum est libero, porta elementum scelerisque fermentum,
  rhoncus sodales metus`,
    author: "Anzor Erqomaishvili",
    posted: "15 November",
    likedcount: 15,
    background: "",
    comments: [],
    likedby: [],
  },
  {
    title: `Nam non tortor mattis, tincidunt lorem ut, pellentesque odio`,
    post: `  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
  vestibulum dolor at justo porttitor rhoncus Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
  vestibulum dolor at justo porttitor rhoncus Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
  vestibulum dolor at justo porttitor rhoncus`,
    author: "Anzor Erqomaishvili",
    posted: "15 November",
    likedcount: 15,
    background: "",
    comments: [],
    likedby: [],
  },
];
